import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const makeVersionRequest = async () => {
  const response = await fetch(`/meta.json?${new Date().getTime()}`, {
    cache: "no-cache",
  });
  return response.json();
};

export const validatePanelVersion = createAsyncThunk(
  "validatePanelVersion",
  makeVersionRequest,
);

type PanelState = {
  panelVersion: string | null;
  needToResetStorage: boolean;
};

const initialState: PanelState = {
  panelVersion: null,
  needToResetStorage: false,
};

const panelSlice = createSlice({
  name: "panel",
  initialState,
  reducers: {
    resetStorage(state) {},
  },
  extraReducers: (builder) => {
    builder.addCase(validatePanelVersion.fulfilled, (state, { payload }) => {
      const currentVersion = payload.version;

      if (
        state.panelVersion === currentVersion ||
        state.panelVersion === null
      ) {
        state.panelVersion = currentVersion;
        state.needToResetStorage = false;
      } else {
        state.needToResetStorage = true;
      }
    });
  },
});

export const { resetStorage } = panelSlice.actions;
export default panelSlice.reducer;
